module.exports = __webpack_public_path__ + "img/clipboard-tick.27b737a9.svg";